// src/pages/TeklifFatura.js
import React, { useState, useEffect } from 'react';
import '../pages/TeklifFatura.css';
import TeklifFaturaPDF from './TeklifFaturaPDF'; // ✅ PDF bileşeni

const TeklifFatura = () => {
  const [kayitlar, setKayitlar] = useState([]);
  const [filtre, setFiltre] = useState('');
  const [secilen, setSecilen] = useState(null);

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setKayitlar(veriler);
  }, []);

  const filtrelenmis = kayitlar.filter(
    (item) =>
      item.firma.toLowerCase().includes(filtre.toLowerCase()) ||
      item.model.toLowerCase().includes(filtre.toLowerCase()) ||
      item.seriNo.toLowerCase().includes(filtre.toLowerCase())
  );

  const faturaOlustur = (data) => {
    setSecilen(data);
    alert(`✅ Fatura detayları gösteriliyor:\nFirma: ${data.firma}`);
  };

  return (
    <div className="fatura-container">
      <h2>🧾 Teklif → Fatura Dönüştürücü</h2>
      <input
        type="text"
        placeholder="Firma, model veya seri no ile ara"
        value={filtre}
        onChange={(e) => setFiltre(e.target.value)}
        className="filtre-input"
      />
      <div className="fatura-liste">
        {filtrelenmis.map((kayit, i) => (
          <div key={i} className="fatura-kart">
            <p><strong>Firma:</strong> {kayit.firma}</p>
            <p><strong>Model:</strong> {kayit.model}</p>
            <p><strong>Seri No:</strong> {kayit.seriNo}</p>
            <button onClick={() => faturaOlustur(kayit)}>📄 Fatura Görüntüle</button>
          </div>
        ))}
      </div>

      {secilen && (
        <div className="fatura-detay">
          <h3>📘 Fatura Detayı</h3>
          <p><strong>Firma:</strong> {secilen.firma}</p>
          <p><strong>Model:</strong> {secilen.model}</p>
          <p><strong>Seri No:</strong> {secilen.seriNo}</p>
          <p><strong>Tarih:</strong> {new Date().toLocaleDateString()}</p>
          <p><strong>Fatura No:</strong> FTR-{Date.now()}</p>

          {/* ✅ PDF çıktısı için bileşen */}
          <TeklifFaturaPDF teklif={secilen} />
        </div>
      )}
    </div>
  );
};

export default TeklifFatura;
